export default function StreamingCursor() {
  return (
    <span className="ml-0.5 inline-block h-4 w-0.5 animate-pulse bg-gray-400 align-text-bottom" />
  );
}
